import { useCallback } from 'react'

import { useCrudSelection, useEditingStateWithCtx } from '@/atoms'

export function useActions() {
  const { editing, setEditing } = useEditingStateWithCtx('vehicle')
  const [selection, setSelection] = useCrudSelection('unifiedVehicles')

  const onCreate = useCallback(() => {
    setSelection('reset')
    setEditing([...selection])
  }, [setEditing, setSelection, selection])

  return { editing, onCreate }
}
